import Dashboard from "./views/Dashboard";
import Gateways from "./views/Gateways";
import PaymentGateways from "./views/PaymentGateways";
import Products from "./views/Products";
import Profile from "./views/Profile";
import WebhookLogs from "./views/WebhookLogs";
import Orders from "./views/Orders";
import LandingCMS from "./views/LandingCMS";
import SiteSettings from "./views/SiteSettings";
import AccountSettings from "./views/AccountSettings";
import WarehouseStock from "./views/WarehouseStock";
import ProductCoding from "./views/ProductCoding";
import { FaSitemap, FaCogs } from "react-icons/fa";

import {
  HomeIcon,
  GatewayIcon,
  ProductIcon,
  SaleIcon,
  PersonIcon,
  ActivityIcon,
  CreditIcon,
  DocumentIcon,
} from "./components/Icons/Icons";

var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "داشبورد",
    icon: <HomeIcon color="inherit" />,
    component: Dashboard,
    layout: "/",
  },
  {
    path: "/gateways",
    name: "Gateways",
    rtlName: "درگاه‌های فروش",
    icon: <GatewayIcon color="inherit" />,
    component: Gateways,
    layout: "/",
  },
  {
    path: "/payment-gateways",
    name: "PaymentGateways",
    rtlName: "درگاه‌های پرداخت",
    icon: <CreditIcon color="inherit" />,
    component: PaymentGateways,
    layout: "/",
  },
  {
    path: "/products",
    name: "Products",
    rtlName: "محصولات",
    icon: <ProductIcon color="inherit" />,
    component: Products,
    layout: "/",
  },
  {
    path: "/product-coding",
    name: "ProductCoding",
    rtlName: "کدینگ کالا",
    icon: <FaSitemap color="inherit" />,
    component: ProductCoding,
    layout: "/",
  },
  {
    path: "/warehouse-stock",
    name: "WarehouseStock",
    rtlName: "موجودی از فایل انبار",
    icon: <DocumentIcon color="inherit" />,
    component: WarehouseStock,
    layout: "/",
  },
  {
    path: "/orders",
    name: "Orders",
    rtlName: "سفارش‌ها",
    icon: <SaleIcon color="inherit" />,
    component: Orders,
    layout: "/",
  },
  {
    path: "/webhook-logs",
    name: "WebhookLogs",
    rtlName: "لاگ وب‌هوک‌ها",
    icon: <ActivityIcon color="inherit" />,
    component: WebhookLogs,
    layout: "/",
  },
  {
    path: "/users",
    name: "Users",
    rtlName: "کاربران",
    icon: <PersonIcon color="inherit" />,
    component: Profile,
    layout: "/",
    superAdminOnly: true,
  },
  {
    path: "/profile",
    name: "Profile",
    rtlName: "پروفایل",
    icon: <PersonIcon color="inherit" />,
    component: Profile,
    layout: "/",
  },
  {
    path: "/account-settings",
    name: "Account Settings",
    rtlName: "تنظیمات همگام‌سازی",
    icon: <FaCogs color="inherit" />,
    component: AccountSettings,
    layout: "/",
  },
  {
    path: "/site-settings",
    name: "Site Settings",
    rtlName: "تنظیمات سایت",
    icon: <HomeIcon color="inherit" />,
    component: SiteSettings,
    layout: "/",
    requiresSite: true,
  },
  {
    path: "/landing-cms",
    name: "Landing CMS",
    rtlName: "مدیریت لندینگ",
    icon: <HomeIcon color="inherit" />,
    component: LandingCMS,
    layout: "/",
    requiresSite: true,
  },
];

export default dashRoutes;
